function config() {
  return {
    // Build-time
    assetPath: 'https://assets.hu-production.be',
    publicPath: 'https://assets.hu-production.be/betelgeuse/',
    imagesPath: 'https://images.hu-production.be',
    failIfMissingTranslation: true,
    gaTrackingId: 'UA-11066411-1', // Betelgeuse (UA)
    gaTrackingDomain: 'healthunlocked.com',
    ga4TrackingId: 'G-PWYN7K2H5K', // G4 Betelgeuse (GA4), _ga_PWYN7K2H5K cookie in cookieControl.js

    buildOnlyFirstLocal: false,

    listenOnHttps: true,

    // Build-time and run-time
    environment: 'production',

    // Run-time
    apiPath: '',
    classifierApiPath: 'https://classifier-api.hu-production.be',
    meteorUrl: 'wss://healthunlocked.com',
    meteorPath: '/ws',

    // Footfall
    footfallUrl: '/footfall',

    // Browser Notifications
    vapidPublicKey: 'BEI3Zd1ILrTsBDv-YyH5WCV8XixGogWEuEBnBoy45dY4Q5dqvY0H2-NuFSkzabRnDyxRftqCouvx_fc7sx1Zkqw',

    cookieControlApiKey: '21ad29290cdd60a97ce05df1864167a9764044e4',
  };
}

module.exports = config;



// WEBPACK FOOTER //
// ./config/production.js